<template>
  <div class="contactUs flex justify-center" :style="getBg">
    <div class="flex justify-center contactUs-1 my-16">
      <div class="lg:grid grid-cols-12 gap-12 px-28 py-28 box">
        <div class="col-span-6 flex flex-col justify-center">
          <div class="text-4xl text-left font-semibold pt-4 text-white">{{ contact.title }}</div>
          <div class=" text-base text-left pt-4 text-white" v-html="contact.description"></div>
        </div>
        <div class="contactUs-2 col-span-6 ml-14">
          <div class=" mx-auto items-center text-white">
            <div class="flex items-start mb-3" v-for="item in contact.contact" :key="item.id">
              <img :src="$path + item.image.data?.attributes.url" alt="">
              <div>
                <div class="ml-4 mb-4" v-for="itemB in item.tab" :key="itemB.id">
                  <div class=" text-xl">{{ itemB.title }}</div>
                  <div class="value mt-2">{{ itemB.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import $ from 'jquery'
import { mapGetters } from 'vuex'
import { getContactUs } from '@/api/index'
export default {
  name: 'Home',
  data() {
    return {
      isAgree: false,
      submitForm: {},
      xsShow: false, // 手机显示
      activeWidth: window.innerWidth,
      contact: {},
      imgUrl: ''
    }
  },
  watch: {
    activeWidth: {
      handler(val, oldVal) {
        if (val <= 416) {
          this.xsShow = true
        } else {
          this.xsShow = false
        }
      },
      deep: true, // true 深度监听
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      lang: 'getLang'
    }),
    lang() {
      return this.$store.state.lang
    },
    getBg() {
      return this.imgUrl && `background-image: url(${this.imgUrl})`
    }
  },
  components: {},
  created() {
    this.getContactUs()
  },
  mounted() {
  },
  methods: {
    loadBackgroundImage(imageUrl) {
      const img = new Image();
      img.onload = () => {
        // 图片加载完成，设置背景样式
        this.imgUrl = imageUrl
      };
      // 开始加载图片
      img.src = imageUrl;
    },
    async getContactUs() {
      const params = {
        'populate[contact][populate][tab][fields]': '*',
        'populate[contact][populate][image][fields]': 'url',
        'populate[image][fields]': 'url'
      }
      const result = await getContactUs(params)
      this.contact = result.data.attributes
      this.imgUrl = this.$path + this.contact.image?.data?.attributes?.url
      // this.loadBackgroundImage(this.$path + this.contact.image?.data?.attributes?.url)
    }
  },
}
</script>

<style lang="less" scoped>
.contactUs {
  padding: 5rem 0;
  background: #F9FAFB;
  background-image: url("../../assets/images/support/bg.svg");

  .contactUs-1 {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.56));
    width: 50%;
  }

  .value {
    color: rgba(255, 255, 255, 0.60);
  }
}

@media screen and (max-width: 768px) {
  .contactUs-1 {
    width: 100% !important;

    .py-28 {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    &.w-1\/2 {
      width: 100%;
    }

    .box {
      padding-left: 3rem;
      padding-right: 3rem;
    }

  }

  .contactUs-2 {
    margin-top: 2rem;
    margin-left: 0;
  }

}
</style>
